import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { FronteggProvider } from "@frontegg/react";
import { createContext, useMemo } from "react";
function mapEnvironmentToFronteggConfig(environment) {
    switch (environment) {
        case "dev":
            return {
                baseUrl: "https://auth.dev.c12r.io",
                clientId: "4b4bbba6-3b12-4d95-b2d8-5227cc87c0a1",
                isCombinedLogin: true,
            };
        case "staging":
            return {
                baseUrl: "https://auth.stg.c12r.io",
                clientId: "f2c7ea79-eeae-4f40-aba0-2f95f5811ce9",
                isCombinedLogin: false,
            };
        case "prod":
            return {
                baseUrl: "https://auth.climatepartner.com",
                clientId: "5e6e8b4d-812b-4ab3-8aa5-562b9af72fbb",
                isCombinedLogin: false,
            };
        default:
            return null;
    }
}
export const FronteggConfigContext = createContext(null);
export const AuthProvider = ({ children, environment }) => {
    const fronteggConfig = mapEnvironmentToFronteggConfig(environment);
    const configForContext = useMemo(() => fronteggConfig
        ? {
            isCombinedLogin: fronteggConfig.isCombinedLogin,
            baseUrl: fronteggConfig.baseUrl,
        }
        : null, [fronteggConfig]);
    if (!fronteggConfig) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx(FronteggProvider, { contextOptions: {
            baseUrl: fronteggConfig.baseUrl,
            clientId: fronteggConfig.clientId,
        }, hostedLoginBox: true, entitlementsOptions: { enabled: true }, authOptions: { keepSessionAlive: true }, children: _jsx(FronteggConfigContext.Provider, { value: configForContext, children: children }) }));
};
//# sourceMappingURL=AuthProvider.js.map